module.exports = "//static.hsappstatic.net/ecosystem-marketplace-apps-base/static-1.9301/img/video-thumb-overlay.png"